module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAOCAYAAAAxDQxDAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABuSURBVHgB5dA7CoAwEATQwV6IhUXAIve/jK2dRxBPoBtJQATDbD5VBqYbeMsCPWWSGsV+VO6fzNJDuksdsffAJj2hxExALgKzAYnbBco4AvPICu6gbCy+qxhJYbY28odVeReDNUO+WFPknQHd5wYOTSdb7NeHgAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/scenes/LandingPage/images/new/down-arrow.png
// module id = 335
// module chunks = 0